import { createContext, useContext, useState, useCallback, useRef } from "react";
import { SCENES } from "@/data/scenes";

const Ctx = createContext(null);

export function ExperienceProvider({ children }) {
  const [sceneIndex, setSceneIndex] = useState(0);
  const [hour, setHour] = useState(SCENES[0].hour);
  const [modal, setModal] = useState(null);
  const [soundOn, setSoundOn] = useState(false);
  const [finale, setFinale] = useState(0);
  const [started, setStarted] = useState(false);
  const jumpRef = useRef(null);

  const scene = SCENES[sceneIndex];
  const phase = finale > 0.35 ? "dawn" : scene.phase;
  const currentTag = finale > 0.35 ? "eligibility-finale" : scene.id;

  const open = useCallback((type) => setModal(type), []);
  const close = useCallback(() => setModal(null), []);
  const jumpTo = useCallback((i) => jumpRef.current && jumpRef.current(i), []);

  return (
    <Ctx.Provider value={{ sceneIndex, setSceneIndex, scene, hour, setHour, phase, modal, open, close, soundOn, setSoundOn, finale, setFinale, started, setStarted, jumpRef, jumpTo, currentTag }}>
      {children}
    </Ctx.Provider>
  );
}

export const useExperience = () => useContext(Ctx);
